import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=f266d8f8&scoped=true"
var script = {}
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=f266d8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f266d8f8",
  null
  
)

export default component.exports